export default __webpack_public_path__ + "static/media/protocol-1.bf2d703d.png";